import { apiClient } from 'pobble-components/dist/api'

export const apiGetStudent = (id, params) =>
  apiClient.get(`v3/accounts/${id}`, { params })

export const apiUpdateStudent = (id, data, params) =>
  apiClient.put(`v3/accounts/${id}/update_student`, data, { params })

export const apiRetireStudent = id =>
  apiClient.delete(`v3/students/${id}/retire`)

export const apiCreateStudent = (shooldId, data, params) =>
  apiClient.post(`v3/schools/${shooldId}/students`, data, { params })

export const apiResetStudentPasscode = (id, params) =>
  apiClient.put(`v3/accounts/${id}/reset_student_passcode`, {}, { params })

export const apiAddStudentToAGroup = (data, params) =>
  apiClient.put('v3/group_students/add', data, { params })

export const apiRemoveStudentFromGroup = data =>
  apiClient.delete('v3/group_students/remove', { data })

export const apiParseCsvOfStudents = data => {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  return apiClient.post('v3/students/parse_csv_of_students', formData)
}

export const apiIncrementAgeGroup = (id, params) =>
  apiClient.put(`v3/accounts/${id}/increment_year_group`, {}, { params })

export const apiUploadPermissionSlip = (pupilId, permissionSlip, params) => {
  const formData = new FormData()
  formData.append('permission_slip', permissionSlip)
  return apiClient.post(`/v3/accounts/${pupilId}/permission_slips`, formData, {
    params
  })
}

export const apiGetPermissionSlips = (id, params) =>
  apiClient.get(`v3/accounts/${id}/permission_slips`, { params })

export const apiDeletePermissionSlip = id =>
  apiClient.delete(`/v3/permission_slips/${id}`)

export const apiAddPermissionToStudent = id =>
  apiClient.put(`/v3/accounts/${id}/add_school_leader_permission`)

export const apiRemovePermissionFromStudent = id =>
  apiClient.put(`/v3/accounts/${id}/remove_school_leader_permission`)

export const apiExportStudentsToCSV = ids =>
  apiClient.post(`/v3/students_generate_csv_reports`, { student_ids: ids })
